// services/hospitalType.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IHospitalType } from "../hospitalTypeModal";

export const getAllHospitalTypes = createAsyncThunk(
  "HospitalType/FindAllHospitalType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HospitalType/FindAllHospitalType`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Hospital Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createHospitalType = createAsyncThunk(
  "HospitalType/InsertHospitalType",
  async (hospitalTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HospitalType/InsertHospitalType`,
        hospitalTypeData,
      );
      SuccessToast(
        response.data?.Details || "Hospital Type created successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Hospital Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateHospitalType = createAsyncThunk(
  "HospitalType/UpdateHospitalType",
  async (hospitalTypeData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HospitalType/UpdateHospitalType`,
        hospitalTypeData,
      );
      SuccessToast(
        response.data?.Details || "Hospital Type updated successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Hospital Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteHospitalType = createAsyncThunk(
  "HospitalType/DeleteHospitalType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HospitalType/DeleteHospitalType`,
        { ID },
      );
      SuccessToast(
        response.data?.Details || "Hospital Type deleted successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Hospital Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getHospitalTypeByID = createAsyncThunk(
  "HospitalType/FindByIDHospitalType",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HospitalType/FindByIDHospitalType`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive ? 1 : 2,
      } as IHospitalType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Hospital Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveHospitalTypes = createAsyncThunk(
  "HospitalType/FindAllActiveHospitalType",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/HospitalType/FindAllActiveHospitalType`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Hospital Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveHospitalType = createAsyncThunk(
  "HospitalType/ActiveInActiveHospitalType",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HospitalType/ActiveInActiveHospitalType`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Hospital Type status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
